import { ScgpUserSortField } from "@saleor/graphql";
import { UserListSortField } from "@saleor/userManagement/urls";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryUserListManagementField(
  sort: UserListSortField
): ScgpUserSortField {
  switch (sort) {
    case UserListSortField.user_group:
      return ScgpUserSortField.USER_GROUP;
    case UserListSortField.sale_group:
      return ScgpUserSortField.SALE_GROUP;
    case UserListSortField.sale_organization:
      return ScgpUserSortField.SALE_ORGANIZATION;
    case UserListSortField.bu:
      return ScgpUserSortField.BU;
    case UserListSortField.first_name:
      return ScgpUserSortField.FIRST_NAME;
    case UserListSortField.last_name:
      return ScgpUserSortField.LAST_NAME;
    default:
      return undefined;
  }
  // TODO SORT
}

export const getSortQueryUserListManagementVariables = createGetSortQueryVariables(
  getSortQueryUserListManagementField
);
